import { Button, Divider, Typography } from 'antd'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { dashboardRoutes } from '../../setup/config'
import { titles } from '../../setup/messages'
import { GiftList } from './GiftList'


const GiftPage: React.FC = () => (
  <Fragment>
    <Typography.Title level={2}>{titles.gifts}</Typography.Title>
    <div style={{ marginBottom: 16 }}>
      <Button>
        <Link to={dashboardRoutes.newGiftPage}>
          Add new
        </Link>
      </Button>
    </div>
    <Divider />
    <GiftList />
  </Fragment>
)

export default GiftPage
